import {Button, ButtonGroup, Col, Container, Nav, NavItem, NavLink, Row} from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import React, {useEffect, useState} from "react";
import {MODALS, ModalState} from "./constants/modals";
import usePermissions from "../../../hooks/usePermissions";
import NoSearchResult from "../../../components/Common/NoSearchResult";
import ListCommonOrders from "./components/ListCommonOrders";
import {useQuery} from "@tanstack/react-query";
import {CommonOrderService} from "../../../services/common_order.service";
import {useNavigate} from "react-router-dom";
import classnames from "classnames";

const CommonTrafficOrders = () => {
    document.title = "Common Orders | Dashboard";

    const {hasPermission} = usePermissions();
    const navigate = useNavigate();

    const statusMap = new Map([["1", "Active"], ["2", "Waiting"], ["3", "Not Active"]])
    const statusApiMap = new Map([["1", CommonOrderService.getCommonOrders], ["2", CommonOrderService.getCommonOrdersWaiting], ["3", CommonOrderService.getCommonOrdersNotActive]])
    const [activeTab, setActiveTab] = useState("1");

    const [modalState, setModalState] = useState<ModalState>({
        idAdd: false,
        isInfoOrder: false,
        isAssignOrder: false,
        isUpdateOrder: false,
        isChangeStatus: false,

        selectedDate: null,
        selectedOrderId: null,
        selectedOfficeId: null,
        selectedCommonOrderId: null,
    });

    const toggleModal = (key: keyof ModalState, orderId?: number | null, officeId?: number | null, commonOrderId?: number | null, date?: string | null) => {
        setModalState((prevState) => ({
            ...prevState,
            [key]: !prevState[key],
            selectedDate: date || null,
            selectedOrderId: orderId || null,
            selectedOfficeId: officeId || null,
            selectedCommonOrderId: commonOrderId || null,
        }));
    };

    const toggleTab = (tab: any) => {
        if (activeTab !== tab) {
            setActiveTab(tab)
        }
    };

    useEffect(() => {
        const permission = hasPermission('view-common-orders');
        if (!permission) {
            navigate('/no-access');
        }
    }, [hasPermission, navigate]);

    const {
        data: commonOrders,
        isLoading,
        isError,
    } = useQuery({
        queryKey: ["keyCommonOrders", statusMap.get(activeTab)],
        queryFn: () => statusApiMap.get(activeTab)?.call({}),
        retry: false,
    });

    return (
        <div className="page-content">
            <Container fluid>
                <Breadcrumbs title="Dashboard" breadcrumbItem="Common Orders"/>

                <Row>
                    <Col lg="12">
                        <Nav pills className="navtab-bg nav-justified mb-4">
                            {Array.from(statusMap.keys()).map((tabId) => (
                                    <NavItem key={tabId}>
                                        <NavLink
                                            style={{cursor: "pointer"}}
                                            className={classnames({active: activeTab === tabId})}
                                            onClick={() => toggleTab(tabId)}
                                        >
                                            {statusMap.get(tabId)}
                                        </NavLink>
                                    </NavItem>
                                )
                            )}
                        </Nav>
                    </Col>
                </Row>

                {hasPermission("create-common-orders") &&
                    <Row className="align-items-center">
                        <Col md={12} className="d-sm-flex justify-content-between">
                            <div className="align-items-center justify-content-end gap-2 mb-3">
                                <ButtonGroup>
                                    <Button onClick={() => toggleModal("idAdd")} className="btn btn-light d-flex align-items-center gap-1">
                                        <i className="bx bx-plus"></i> Add Common Order
                                    </Button>
                                </ButtonGroup>
                            </div>
                        </Col>
                    </Row>}

                <Row>
                    {!isLoading && commonOrders?.data?.length > 0
                        && <ListCommonOrders commonOrders={commonOrders?.data}
                                             onInfo={(orderId) => toggleModal("isInfoOrder", orderId)}
                                             onUpdate={(commonOrderId) => toggleModal("isUpdateOrder", null, null, commonOrderId)}
                                             onUpdateStatus={(commonOrderId, date) => toggleModal("isChangeStatus", null, null, commonOrderId, date)}
                                             onAssign={(orderId, officeId, commonOrderId) => toggleModal("isAssignOrder", orderId, officeId, commonOrderId)}/>}

                    {!isLoading && commonOrders?.data?.length === 0 && (<NoSearchResult/>)}
                    {isLoading && (<NoSearchResult text="Loading..."/>)}
                    {isError && (<NoSearchResult/>)}

                    {/*{pagination.total_page > 1 && (*/}
                    {/*    <ServerPagination totalPages={pagination.total_page}*/}
                    {/*                      page={pagination.current_page}*/}
                    {/*                      onChange={(page) => updateFilter({page})}/>*/}
                    {/*)}*/}
                </Row>

                {MODALS.map(({key, Component}) =>
                    modalState[key as keyof ModalState] ? (
                        <Component
                            key={key}
                            orderId={modalState.selectedOrderId || 0}
                            officeId={modalState.selectedOfficeId || 0}
                            commonOrderId={modalState.selectedCommonOrderId || 0}
                            date={modalState.selectedDate || ""}
                            isOpen={!!modalState[key as keyof ModalState]}
                            toggle={() => toggleModal(key as keyof ModalState)}
                        />
                    ) : null
                )}
            </Container>
        </div>
    )
}

export default CommonTrafficOrders;